import graphql from 'babel-plugin-relay/macro';

export const GENERATE_RESUME_MUTATION = graphql`
  mutation ResumeMutation($pid: ID!, $previewID: String) {
    generateResumeBackground(pid: $pid, previewID: $previewID) {
      uuid
    }
  }
`;
